import BirthdaysToday from "./BirthdaysToday";

export default BirthdaysToday;
